import { PublicClientApplication } from "@azure/msal-browser";
import msalConfig from "../authConfig";

// Initialize the MSAL application object
export const msalInstance = new PublicClientApplication(msalConfig);

// Export the initialization promise for awaiting in authFetch
export const msalReady = msalInstance.initialize();
